import { useEffect } from "react";
import { ar } from "../locales/ar";
import { en, type Key } from "../locales/en";
import { usePrefs } from "./prefs";

const dicts = { en, ar } as const;

export type TFn = (key: Key, vars?: Record<string, string | number>) => string;

export function translate(
  locale: "en" | "ar",
  key: Key,
  vars?: Record<string, string | number>,
): string {
  let s: string = dicts[locale][key] ?? en[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

export function useT(): TFn {
  const locale = usePrefs((s) => s.locale);
  return (key, vars) => translate(locale, key, vars);
}

/** Keeps <html lang dir> in sync with the locale. */
export function useLocaleDom() {
  const locale = usePrefs((s) => s.locale);
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
  }, [locale]);
}

export function formatCost(usd: number): string {
  if (usd === 0) return "$0";
  return usd < 0.01 ? `$${usd.toFixed(4)}` : `$${usd.toFixed(2)}`;
}
